"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _constants = require("../Icon/constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function TextInputIcon(_ref) {
  var errorIcon = _ref.errorIcon,
      questionmark = _ref.questionmark,
      errorInTooltip = _ref.errorInTooltip,
      verified = _ref.verified,
      error = _ref.error,
      search = _ref.search,
      rest = _objectWithoutProperties(_ref, ["errorIcon", "questionmark", "errorInTooltip", "verified", "error", "search"]);

  var iconName;

  if (!error) {
    if (questionmark) {
      iconName = _constants.ICON_TYPE_TOOLTIP;
    }

    if (verified) {
      iconName = _constants.ICON_TYPE_VERIFIED;
    }

    if (search) {
      iconName = _constants.ICON_TYPE_SEARCH;
    }
  } else if (errorIcon || errorInTooltip) {
    iconName = _constants.ICON_TYPE_ERROR;
  }

  return iconName ? /*#__PURE__*/_react.default.createElement(_Icon.default, _extends({}, rest, {
    type: iconName
  })) : /*#__PURE__*/_react.default.createElement("div", null);
}

TextInputIcon.propTypes = {
  errorIcon: _propTypes.default.bool,
  questionmark: _propTypes.default.bool,
  errorInTooltip: _propTypes.default.bool,
  verified: _propTypes.default.bool,
  search: _propTypes.default.bool,
  error: _propTypes.default.string
};
TextInputIcon.defaultProps = {
  errorIcon: false,
  questionmark: false,
  errorInTooltip: false,
  verified: false,
  search: false,
  error: null
};
var _default = TextInputIcon;
exports.default = _default;